import React, { useEffect, useState } from "react";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ExchangePairsFilter from "./ExchangePairsFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";
import ExchangePairsList from "./ExchangePairsList";
import Notification from "../../../elements/notification/Notification";
import ItemsPerPageSelect from "../../../elements/filter/ItemsPerPageSelect";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import { itemsPerPageValue } from "../../../../utils/ItemsPerPageValue";
import { HTTP_STATUSES } from "../../../../utils/consts";

import MaterialPagination from "../../../styles/materialPagination";
import { StyledExchangePairsWrapper } from "./styledExchangePairs";

const ExchangePairsContainer = () => {
  const { t } = useTranslation("exchangerPage");

  const [pairs, setPairs] = useState(null);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", "exchange-pairs", false, true),
    "inService.name": checkFilterItem(history, "inService.name", null),
    "inCurrency.asset": checkFilterItem(history, "inCurrency.asset", null),
    "outService.name": checkFilterItem(history, "outService.name", null),
    "outCurrency.asset": checkFilterItem(history, "outCurrency.asset", null),
    "percent[gte]": checkFilterItem(history, "percent[gte]", null, true),
    "percent[lte]": checkFilterItem(history, "percent[lte]", null, true),
    "constant[gte]": checkFilterItem(history, "constant[gte]", null, true),
    "constant[lte]": checkFilterItem(history, "constant[lte]", null, true)
  });

  const [totalPageCount, setTotalPageCount] = useState(null);

  const fetchPairs = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/exchange-pairs" + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setPairs(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    });
  };

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  useEffect(() => {
    fetchPairs();
  }, [filterData]);

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <Helmet>
        <title>{t("pairs.meta.title")}</title>
      </Helmet>
      <StyledExchangePairsWrapper>
        <div className="exchange-pairs-head">
          <ExchangePairsFilter
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <ItemsPerPageSelect
            itemsPerPage={filterData.itemsPerPage}
            setItemsPerPage={(data) => setFilterData({
              ...filterData,
              "itemsPerPage": data,
              page: 1
            })}
          />
        </div>
        <FilterAppliedList
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <ExchangePairsList
          pairs={pairs}
          notification={notification}
          setNotification={setNotification}
          fetchPairs={fetchPairs}
        />
        {totalPageCount > 0 &&
          <MaterialPagination
            count={totalPageCount}
            shape="rounded"
            page={filterData.page}
            onChange={(event, page) => onChangePage(event, page)}
          />}
      </StyledExchangePairsWrapper>
    </>
  );
};

export default ExchangePairsContainer;